import { useEffect, useState } from "react";

// Per-user/device POS layout preference (presentation only — never touches cart state).
const EVT = "neec-pos-view";
const key = (uid) => `neec_pos_view_${uid || "anon"}`;

const VIEWS = ["standard", "counter", "full"];
export const readPosView = (uid) => { const v = localStorage.getItem(key(uid)); return VIEWS.includes(v) ? v : "standard"; };

export const setPosView = (uid, view) => {
  localStorage.setItem(key(uid), view);
  window.dispatchEvent(new CustomEvent(EVT, { detail: view }));
};

export function usePosView(uid) {
  const [view, setView] = useState(() => readPosView(uid));
  useEffect(() => {
    setView(readPosView(uid));
    const h = (e) => setView(e.detail);
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, [uid]);
  return [view, (v) => setPosView(uid, v)];
}
